import {
  GET_ITEMS,
  BEGIN_ITEMS_FETCH,
  ABORT_ITEMS_FETCH,
  EDIT_ACTUAL_ORDER,
  SET_CURRENT_PAGE,
  SET_PAGE_SIZE,
  GET_BATCH_DATA,
  UPDATE_TABLE_ORDER,
  UPDATE_TABLE_CELL_VALUE,
  START_ACTUAL_ORDER_UPDATE,
  END_ACTUAL_ORDER_UPDATE,
  GET_FILTERS,
  GET_GLOBAL_FILTER,
  SET_FILTERED_ROWS,
} from "../actions/types";

const initialState = {
  loadingFetch: true,
  loadingFetchBatchData: true,
  items: [],
  filteredItems: [],
  filters: {},
  globalFilter: '',
  batchData: null,
  pageIndex: 0,
  pageSize: 50,
  isActualOrderUpdateInProgress: false,
  // a list of location code - material concatentations (IDs)
  itemIds: []
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SET_CURRENT_PAGE:
      return {
        ...state,
        pageIndex: payload,
      };
    case SET_PAGE_SIZE:
      return {
        ...state,
        pageSize: payload,
      };
    case GET_ITEMS:
      return {
        ...state,
        items: payload,
        itemIds: payload.map((payloadItem) => payloadItem.location_code_concatenation),
        loadingFetch: false,
      };
    case GET_FILTERS: {
      const updatedFilters = {
        ...state.filters,
        ...payload,
      };

      return {
        ...state,
        filters: Object.fromEntries(
          Object.entries(updatedFilters).filter(([, value]) => value !== undefined)
        ),
      };
    }
    case GET_GLOBAL_FILTER:
      return {
        ...state,
        globalFilter: payload || ''
      }
    case SET_FILTERED_ROWS:
      return {
        ...state,
        filteredItems: payload,
      }
    case GET_BATCH_DATA:
      return {
        ...state,
        batchData: payload,
        loadingFetchBatchData: false,
      };
    case EDIT_ACTUAL_ORDER:
      return {
        ...state,
        loadingFetch: false,
        items: state.items.map((item) =>
          item.location_code_concatenation ===
          payload.location_code_concatenation
            ? payload
            : item
        ),
        itemIds: state.items.map((item) => item.location_code_concatenation),
      };
    case UPDATE_TABLE_CELL_VALUE:
      return {
        ...state,
        items: state.items.map((item) =>
          item.location_code_concatenation === payload.item.location_code_concatenation
            ? payload.item : item
        )
      };
    case BEGIN_ITEMS_FETCH:
      return {
        ...state,
        loadingFetch: true,
      };
    case ABORT_ITEMS_FETCH:
      return {
        ...state,
        loadingFetch: false,
        items: [],
        itemIds: [],
      };
    case UPDATE_TABLE_ORDER:
      return{
        ...state,
        items: payload,
        itemIds: payload.map((payloadItem) => payloadItem.location_code_concatenation),
      }
    case START_ACTUAL_ORDER_UPDATE:
      return {
        ...state,
        isActualOrderUpdateInProgress: true,
      }
    case END_ACTUAL_ORDER_UPDATE:
      return {
        ...state,
        isActualOrderUpdateInProgress: false,
      }
    default:
      return state;
  }
}
